import restService from "../rest-service/RestService";
import { ITagValue } from "../../common/models/ITagValue";
import { IGroupManualEntryModel, IGroupManualEntryQueryParams, IManualEntryExportOptions, IMaxRowCountQueryParams, ITagManualEntryModel, ITagManualEntryNewValueParams, ITagManualEntryQueryParams, ITagManualEntryValueParams, ITagValueModel } from "./Models";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";

const ManualEntryDataService = {
    
    getGroupManualEntryData: async function(
        groupID: number,
        date: Date,
        abortSignal? : AbortSignal
    ): Promise<IGroupManualEntryModel> {
        var path: string = `groups/${groupID}/manualentry/values`;

        var params: IGroupManualEntryQueryParams = {
            entryDate: date
        };
        
        const response = await restService.get<IGroupManualEntryModel, IGroupManualEntryQueryParams>(path, abortSignal, params);
        
        return response.data;
    },

     getTagManualEntryData: async function(groupID: number, 
        tagID: number, 
        startDate?: Date, 
        endDate?: Date,
        abortSignal? : AbortSignal): Promise<ITagManualEntryModel> {
        var path: string = [
            "tags",
            tagID,
            "manualentry",
            "values"
        ].join("/");

        var params: ITagManualEntryQueryParams = {
            contextGroupID: groupID,
            startDate: startDate,
            endDate: endDate
        };

        const reponse = await restService.get<ITagManualEntryModel, ITagManualEntryQueryParams>(path, abortSignal, params);

        return reponse.data;
    },

    getDefaultMaxRowCount: async function (groupID: number,
        tagID: number, 
        startDate?: Date,
        abortSignal? : AbortSignal): Promise<number> {
            var path: string = [
                "groups",
                groupID,
                "tags",
                tagID,
                "defaultmaxrowcount"
            ].join("/");

            var params: IMaxRowCountQueryParams = {
                beginDate: startDate
            }
           
            const response = await restService.get<number, IMaxRowCountQueryParams>(path, abortSignal, params);

            return response.data;
        },

    deleteTagValue: async function (groupID: number,
        value: ITagValueModel,
        convertToContractDay?: boolean, 
        abortSignal?: AbortSignal): Promise<string> {
            var path: string = [
                "manualentry",
                "value"
            ].join("/");

            var params: ITagManualEntryValueParams =  {
                contextGroupID: groupID,
                convertToContractDay: convertToContractDay ? true : false
            };

           const response = await restService.delete<ITagValueModel, ITagManualEntryValueParams>(path, abortSignal, params, value);
           return response.statusText;
        },

      updateTagValue: async function (groupID: number, 
        values: Array<ITagValueModel>, 
        convertToContractDay?: boolean,
        abortSignal?: AbortSignal): Promise<void> {

            var path: string = [
                "manualentry",
                "values"
            ].join("/");
            
            var params: ITagManualEntryValueParams = {
                contextGroupID: groupID,
                convertToContractDay: convertToContractDay ? true : false
            };

            await restService.put<Array<ITagValueModel>, ITagManualEntryValueParams, void>(path, values, abortSignal, params);
        },

        saveTagValue: async function (groupID: number,
            value: ITagValue,
            numberValue: number, 
            tagID: number,
            timestamp: Date,
            uomID?: number,
            convertToContractDay?: boolean,
            abortSignal?: AbortSignal): Promise<string> {
    
                var path: string = [
                    "manualentry",
                    "addvalue"
                ].join("/");
                
                var params: ITagManualEntryNewValueParams = {
                    contextGroupID: groupID,
                    numberValue: numberValue,
                    tagID: tagID,
                    uomID: uomID,
                    timestamp: timestamp,
                    convertToContractDay: convertToContractDay ? true : false
                };
    
                const response = await restService.put<ITagValueModel, ITagManualEntryNewValueParams, void>(path, value , abortSignal, params);
                return response.statusText;
            },

        exportGroupManualEntryData: async function (
            groupID: number,
            date: Date,
            notificationKey: string,
            mimeType: ApplicationMimeTypesEnum,
            abortSignal?: AbortSignal
        ):Promise<void> {
            var path: string = `groups/${groupID}/manualentry/export`;
    
            var params: IManualEntryExportOptions = {
                mimeType: mimeType,
                notificationKey: notificationKey,
                entryDate: date.toISOString(),
            };

            await restService.post<IManualEntryExportOptions, void>(path, params, abortSignal);
        }
};

export default ManualEntryDataService;